import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Dispatch, useCallback, useRef, useState } from 'react';
import getNumberOfCareerResultsRequest from '../../../lib/api/getNumberOfCareerResultsRequest';
import careerFilterOptions from '../../../lib/config/project/careerFilterOptions';
import careerSortOptions from '../../../lib/config/project/careerSortOptions';
import useApplySort from '../../../lib/hooks/applySort';
import useClearAllFilters from '../../../lib/hooks/clearAllFilters';
import useSeeAllReuslts from '../../../lib/hooks/seeAllResults';
import useUpdatePotentialFilterForParam from '../../../lib/hooks/updatePotentialFilterForParam';
import MobileFiltersAndSort from '../../shared/MobileFiltersAndSorts';
import DesktopFiltersAndSort from '../DesktopFiltersAndSort';

interface GNOSubHeaderProps {
  setPage: Dispatch<number>;
  setPotentialFilters: Dispatch<any>;
  potentialFilters: any;
}

const GNOSubHeader: React.FC<GNOSubHeaderProps> = ({ setPage, setPotentialFilters, potentialFilters }) => {
  const router = useRouter();
  const [selectedSort, setSelectedSort] = useState(careerSortOptions[0]);

  const resultsRef = useRef<HTMLDivElement>(null);

  // Fetches the potential number of results based on potential filters
  // selected
  const { data: potentialNumberOfResults } = useQuery(
    ['number-of-career-results', JSON.stringify(potentialFilters)],
    () => getNumberOfCareerResultsRequest({ ...potentialFilters }),
  );

  const { data: numberOfResults } = useQuery(
    [`career-number-${JSON.stringify(router.query)}`],
    () => {
      return getNumberOfCareerResultsRequest(router.query as any);
    },
  );

  const { updatePotentialFilterForParam } = useUpdatePotentialFilterForParam(
    potentialFilters,
    setPotentialFilters,
  );

  const resetState = useCallback(() => {
    setPage(1);
  }, []);

  const { clearAllFilters } = useClearAllFilters(
    'careerguide',
    resetState,
  );

  const { applySort } = useApplySort(
    setSelectedSort,
    setPage,
    careerSortOptions,
  );

  const { seeAllResults } = useSeeAllReuslts(
    setPage,
    potentialFilters,
    'careerguide',
  );
  return (
    <section
      ref={resultsRef}
      className="flex flex-col py-10 bg-careerPageHeading lg:py-28"
    >
      <section className="container px-8 mx-auto">
        <h2 className="text-2xl font-bold text-white lg:text-4xl">
          Showing {numberOfResults || 0} Careers.{' '}
          <br className="block lg:hidden" />
          <Link href="/training">
            <span className="font-light underline cursor-pointer hover:text-gray7">
              See programs instead?
            </span>
          </Link>
        </h2>

        <div className="hidden md:block">
          <DesktopFiltersAndSort
            potentialFilters={potentialFilters}
            setPotentialFilters={setPotentialFilters}
            setPage={setPage}
            selectedSort={selectedSort}
            setSelectedSort={setSelectedSort}
            isCareers={true}
            potentialNumberOfResults={potentialNumberOfResults || 0}
          />
        </div>
        <div className="block md:hidden">
          <MobileFiltersAndSort
            filters={careerFilterOptions}
            sortOptions={careerSortOptions}
            selectedSort={selectedSort}
            potentialNumberOfResults={potentialNumberOfResults || 0}
            updatePotentialFilterForParam={updatePotentialFilterForParam}
            clearAllFilters={clearAllFilters}
            applySort={applySort}
            seeAllResults={seeAllResults}
            totalNumberOfResults={numberOfResults || 0}
            isCareers={true}
          ></MobileFiltersAndSort>
        </div>
      </section>
    </section>
  );
};

export default GNOSubHeader;
